import { Model } from "@interfaces/model.interface";
import { Guid } from "guid-typescript";

export interface PurchaseLogLineItemAllocation extends Model {
	lineItemDescription: string;
	lineItemLookupId: Guid;
	partQuantity?: number;
	purchaseLogId: number;
	quantity: number;
	workOrderId: string;
}

export class PurchaseLogLineItemAllocation implements PurchaseLogLineItemAllocation {
	constructor(data?: Partial<PurchaseLogLineItemAllocation>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}